import type {LayoutPayload} from '@github-ui/code-view-types'
import {Banner} from '@primer/react'

export function PreReceiveHookFailureBanner({hookFailure}: {hookFailure?: LayoutPayload['hookFailure']}) {
  if (!hookFailure) return null

  const title = hookFailure.message ? `${hookFailure.message} Pre-receive hooks failed.` : 'Pre-receive hooks failed.'

  return (
    <Banner title={title} variant="critical">
      <Banner.Description>
        <pre>{hookFailure.output}</pre>
      </Banner.Description>
    </Banner>
  )
}
